import store from '@/store/store'
import app from '@/main'

export default socket => {
  socket.on('role', function() {
    store.dispatch('auth/getProfile').then(res => {
      store.commit('UPDATE_USER_INFO', res.data)
      app.$acl.change(res.data.roles)
      window.location = '/'
    })
  })
}
